// Generated by CoffeeScript 1.12.2
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('views/components/question_nav',['require','backbone','perfect-scrollbar','sp/utilities/strip_markdown','etc/definitions'],function(require) {
  var Ps, QuestionNav, View, questionTypes, stripMarkdown;
  View = require('backbone').View;
  Ps = require('perfect-scrollbar');
  stripMarkdown = require('sp/utilities/strip_markdown');
  questionTypes = require('etc/definitions').questionTypes;
  return QuestionNav = (function(superClass) {
    extend(QuestionNav, superClass);

    function QuestionNav() {
      return QuestionNav.__super__.constructor.apply(this, arguments);
    }

    QuestionNav.prototype.id = 'question-nav';

    QuestionNav.prototype.events = {
      "click .question-nav-item": "itemClickHandler"
    };

    QuestionNav.prototype.initialize = function(options) {
      return QuestionNav.__super__.initialize.call(this, options);
    };

    QuestionNav.prototype.render = function() {
      var $ul;
      $ul = $('<ul>').appendTo(this.el);
      this.model.get('questions').forEach(function(question, index) {
        var $li, $questionNum, $title, type;
        $li = $('<li>').addClass('question-nav-item').data('index', index).appendTo($ul);
        type = _.chain(questionTypes).find({
          type: question.type
        }).result('display').value();
        $questionNum = $('<div>').addClass('question-nav-item-index').html("<span><abbr>Q</abbr>" + (index + 1) + "</span>").appendTo($li);
        return $title = $('<h4>').addClass('question-nav-item-title').text(stripMarkdown(question.title)).append($('<span>').text(type)).appendTo($li);
      });
      this.selectQuestionItem(0);
      this.$el.delay(1000).animate({
        left: 0,
        opacity: 1
      });
      Ps.initialize(this.el);
      return this.$el.css({
        left: -(this.$el.outerWidth() + 10),
        opacity: 0
      });
    };

    QuestionNav.prototype.selectQuestionItem = function(index) {
      this.$el.find("li").removeClass('selected');
      return this.$el.find("li:nth-child(" + (index + 1) + ")").addClass('selected');
    };

    QuestionNav.prototype.destroy = function(callback) {
      if (callback == null) {
        callback = function() {};
      }
      return this.$el.animate({
        left: -(this.$el.outerWidth() + 10),
        opacity: 0
      }, 'fast', (function(_this) {
        return function() {
          _this.$el.unbind();
          _this.$el.remove();
          return callback();
        };
      })(this));
    };

    QuestionNav.prototype.itemClickHandler = function(e) {
      var $target, index;
      $target = $(e.target).closest('li');
      index = $target.data('index');
      this.selectQuestionItem(index);
      return this.trigger('select', index);
    };

    return QuestionNav;

  })(View);
});

